var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#265888","fillRule":"evenodd","d":"M11.464 5.614a1.6 1.6 0 0 1 0 2.772L2.4 13.616A1.6 1.6 0 0 1 0 12.23V1.77A1.6 1.6 0 0 1 2.4.384l9.064 5.23Z","clipRule":"evenodd"}));
}

PlayIcon.defaultProps = {"width":"13","height":"14","fill":"none"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
